import { createGlobalStyle } from 'styled-components';

/**
 * Shared Ant Design modal layout + confirm dialog theming (tenant-safe class hooks).
 * Use `className="app-modal-shell--tall-scroll"` on `AppModal` for tall scrollable shells.
 * Use `className: 'app-modal-confirm--themed'` on `Modal.confirm`.
 */
export const AppModalShellGlobalStyles = createGlobalStyle`
    .app-modal-shell--tall-scroll .ant-modal-content {
        max-height: 96vh;
        display: flex;
        flex-direction: column;
    }

    .app-modal-shell--tall-scroll .ant-modal-header {
        position: sticky;
        top: 0;
        z-index: 2;
        background: inherit;
    }

    .app-modal-shell--tall-scroll .ant-modal-footer {
        position: sticky;
        bottom: 0;
        z-index: 2;
        background: inherit;
        margin-top: auto;
    }

    .app-modal-shell--tall-scroll .ant-modal-body {
        flex: 1;
        overflow: auto;
        max-height: calc(96vh - 160px);
        padding: 16px;
        padding-right: 10px;
        background: inherit;
        scrollbar-width: thin;
        scrollbar-color: rgba(138, 152, 167, 0.55) transparent;
    }

    .app-modal-shell--tall-scroll .ant-modal-body::-webkit-scrollbar {
        width: 8px;
    }

    .app-modal-shell--tall-scroll .ant-modal-body::-webkit-scrollbar-track {
        background: transparent;
    }

    .app-modal-shell--tall-scroll .ant-modal-body::-webkit-scrollbar-thumb {
        background: rgba(138, 152, 167, 0.45);
        border-radius: 999px;
        border: 2px solid transparent;
        background-clip: content-box;
    }

    .app-modal-shell--tall-scroll .ant-modal-body::-webkit-scrollbar-thumb:hover {
        background: rgba(138, 152, 167, 0.65);
        border: 2px solid transparent;
        background-clip: content-box;
    }

    .app-modal-confirm--themed .ant-modal-content {
        background: ${({ theme }) => theme.colors.background.secondary} !important;
        border: 1px solid ${({ theme }) => theme.colors.border.light} !important;
    }

    .app-modal-confirm--themed .ant-modal-confirm-title {
        color: ${({ theme }) =>
            theme.colors.background.default === '#141414'
                ? 'rgba(255, 255, 255, 0.88)'
                : 'rgba(0, 0, 0, 0.88)'} !important;
        font-family: var(--font-family-lufga) !important;
        font-weight: 800 !important;
    }

    .app-modal-confirm--themed .ant-modal-confirm-content {
        color: ${({ theme }) => theme.colors.text.secondary} !important;
    }

    .app-modal-confirm--themed .ant-btn {
        border-radius: 12px !important;
        font-family: var(--font-family-lufga) !important;
        font-weight: 700 !important;
    }

    .app-modal-confirm--themed .ant-btn-default {
        background: ${({ theme }) => theme.colors.background.tertiary} !important;
        border-color: ${({ theme }) => theme.colors.border.default} !important;
        color: ${({ theme }) =>
            theme.colors.background.default === '#141414'
                ? 'rgba(255, 255, 255, 0.88)'
                : 'rgba(0, 0, 0, 0.88)'} !important;
    }

    .app-modal-confirm--themed .ant-btn-default:hover {
        background: ${({ theme }) =>
            theme.colors.background.default === '#141414'
                ? 'rgba(255, 255, 255, 0.10)'
                : 'rgba(0, 0, 0, 0.04)'} !important;
        border-color: ${({ theme }) => theme.colors.border.default} !important;
    }

    .app-modal-confirm--themed .ant-btn-primary.ant-btn-dangerous {
        background: ${({ theme }) => theme.colors.error} !important;
        border-color: ${({ theme }) => theme.colors.error} !important;
        color: #ffffff !important;
    }

    .app-modal-confirm--themed .ant-btn-primary.ant-btn-dangerous:hover {
        background: #ff5d5d !important;
        border-color: #ff5d5d !important;
    }
`;
